define(['jquery', 'common'], function ($, Common) {

		var NHCPayment = function() {
			var self = this;
			self.$ervBody = $('#erv-body');
			self.$form = self.$ervBody.find('form[data-js-mainform]');
			self.common = new Common();

			self.initEventHandlers = function() {
				self.$ervBody.find('[name="Input.TypeOfPayment"]').on('change', function () {
					var $input = $(this),
					$invoiceSection = self.$form.find('[data-js="invoicesection"]'),
					$accountSection = self.$form.find('[data-js="accountsection"]'),
					$submitButton = self.$form.find('[data-js="submitbutton"]'),
					$noInvoices =  self.$form.find('[data-js="noinvoices"]');

					if ($input.data('value') === 'account') {
						$invoiceSection.addClass('hide');
						$accountSection.removeClass('hide');
						self.common.forms.disableFormElementsInContainer($accountSection, false);
						self.common.forms.disableFormElementsInContainer($invoiceSection, true);
						$submitButton.removeClass('hide');
						$noInvoices.addClass('hide');
					} else {
						$invoiceSection.removeClass('hide');
						$accountSection.addClass('hide');
						self.common.forms.disableFormElementsInContainer($accountSection, true);
						self.common.forms.disableFormElementsInContainer($invoiceSection, false);

						if ($invoiceSection.length === 0) {
							$noInvoices.removeClass('hide');
							$submitButton.addClass('hide');
						}
					}
				});
			};
		};

		NHCPayment.prototype.init = function () {
			var self = this;
			self.initEventHandlers();

			self.$form.on('submit', function (e) {
				if (self.$form.find('.input-validation-error').length === 0) {
					self.common.forms.activateLoading(self.$form, false);
					return;
				}

				self.common.forms.deactivateLoading(self.$form);

				e.preventDefault();
				e.stopPropagation();
			});
		}

		return NHCPayment;
});